var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.476868,
    y: 0.479492,
    width: 35.9803,
    height: 36.0048,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_340",
    transform: "matrix(0.0111111 0 0 0.0111036 0 0.000339198)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_340",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEKUlEQVR4nO2cy48UdRDHez3CQTngsjtVvVPVi0dJHKZqJFy86M1X4tV48ECiPAwHDx7ghP4J8ggmngyBeCByQKMciF7hpGgg3Hi4cADCw4QdUz0zREhI7Nnt/v1+PfVJKplstrurvl3968evfpVljuM4juM4juM4juM4zrrw+jy/rHnREyje1Zz3CPCXgnxUkE4J0i+CfFGBLgvwdQG+LUh3FHloZr/LvwFfL/8H+eJoG9uWj9q+Rvu0fRc9O1ZrT9vOPN+kna4q8keKdFCAvlGgnxT5kgA/mIjWlI2P+Yf5UPqCdLD0rdNV8zWLnR2Ii33ovqVA+xXosCCfE6AbTQupaz4RdMN8txgsFovJYgsmrF2GfeRdAvRdioJq1ROAdNOGJBuKenm+ULvASjRfZmyAy14jMQF6KEjHaxO8D/yeIv0dOlCNxmhFO/z+uoo8APpYkR+HD45js1UB+mQdM5lXIwhqGKmtmkZrEnn7YoH2rBpBMMOYTZBvDWBrZ2qhR8+a4QPRBMxekqYSubfAuQL9EzoATcWAHklnGapnM9JnwZ3HtGwAxe5phD4T2nFNzYBPVxZaga8EdxzTMkH6q7rQyPdCO67p2b1phA7t9DBFc6HRhR6GzkLPaAwvXIuHDvoi5RtxMkJn4xmbcpYjwS+GSQk9YTRxS+dDi9d6ocfMSU4fCPDV0CK2XeiS3sLCBs35c0G6G1rMVgs9wb6QKfC3sU5GZFWJ3dEBkCjSr6GFbb3QY+YEiw8V+FpogdsudMmr8/MbR5VQ4csgsqok4+gzc5zj8duF1hqFniCd4g1FvpBEoqSY0c/wgo3fTZesZTModMm2paWXBOgrK+WK0v+2CD2hv0ivKPCJ6PxvqdCno/O/LUJv86GD6xbab4bawONduf4lhSsyxaGjV5ax+QvLsC6h/RW8/oye849KjXwm5d9CDXGtH6PFP/zXK3TPp7Jqz+g5n5yteejoI2/3coMax+gdXkDTxA2RvCSsiacOTdySebzTxM2FRhd6OOsZnWyNsgYyaz9UXWigy6Ed18RMkP6sLLQg/RDacZ2JBZ3Ie4M7jmmZAH06ZXmVL7rXuhfdG9Y7KHSWaNvbSJRCd5bBmn6EDkKjN1pZU2MUwxo0xVpdr21p9TPBm1dx/c2rns5sWokgg4atbcc2wZrqKfKxpiozdRYbDP6X/tLSFntmLDvbzkjLTEX6vrGWmc/DDi7YfVOQ9ynQ19ZeOKYFPPp/rfSZfh7FwPsspqDCVqnktPoLsZVTtpgH6bgA/2ithQX5fvOZyfcF+HcBPjv25YD5Zj72mF/M2srOLcubB3nxmmDxjl2WCnxIkI8I8knLrEmjbsu0caPuJ6tm7XfZ/NCycPQB7MJ4m5OjtsR8qNwndt+2Y9ixQsfrOI7jOI7jOI7jOI6TtYR/ARnJav/mE6ILAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeDark);
export default __webpack_public_path__ + "static/media/youtube-dark.6625d4835fe5933ed8ef024f8471da50.svg";
export { ForwardRef as ReactComponent };